import React, { Component } from 'react';
import './style.css';

const links = [
  ['About', '#about'],
  ['Resume', '#resume'],
  ['Videos', '#videos'],
  ['Photos', '#photos'],
  ['Contact', '#contact'],
];

class Header extends Component {
  state = { menuOpen: false };

  closeMenu = () => this.setState({ menuOpen: false });

  render() {
    return (
      <header id="header">
        <a className="brand" href="#about" onClick={this.closeMenu} aria-label="Paige Faure, back to top">
          <img src="/signature.png" alt="Paige Faure" />
        </a>
        <button
          className="menu-toggle"
          type="button"
          aria-expanded={this.state.menuOpen}
          aria-controls="site-navigation"
          onClick={() => this.setState(({ menuOpen }) => ({ menuOpen: !menuOpen }))}
        >
          <span>{this.state.menuOpen ? 'Close' : 'Menu'}</span>
          <span className="menu-toggle-icon" aria-hidden="true">{this.state.menuOpen ? '×' : '☰'}</span>
        </button>
        <nav id="site-navigation" className={this.state.menuOpen ? 'navigation is-open' : 'navigation'} aria-label="Main navigation">
          {links.map(([label, href]) => (
            <a key={href} href={href} onClick={this.closeMenu}>{label}</a>
          ))}
          <a className="social-link" href="https://www.instagram.com/paigefaure/" target="_blank" rel="noopener noreferrer" aria-label="Paige Faure on Instagram">
            <img src="/icons/instagram.svg" alt="" />
          </a>
        </nav>
      </header>
    );
  }
}

export default Header;
